import { getAppUserData } from 'app/@utils'
import { USER_ROLE } from 'app/@common/constants'
import { useEffect, useState } from 'react'
import { useUser } from 'ui-seeker/core'
import { useHistory } from 'react-router-dom'


export default function useAppUserSelector() {

    const {mainHotelsSectionData, role, uidSlave, userId, username} = getAppUserData()
    const isUserMaster = role === USER_ROLE.MASTER
    const [mainUser, setMainUser] = useState(parseInt(uidSlave))
    const userInfoData = mainHotelsSectionData ? mainHotelsSectionData[isUserMaster ? mainUser : userId] : null
    const history = useHistory()
    const { logout } = useUser()

    useEffect(() => {
        if (!mainHotelsSectionData || (!userInfoData && role === USER_ROLE.ADMIN)) {
            logout('/api/session/logout')
            history.push('/login')
        }
    }, [mainHotelsSectionData, userInfoData, logout, history, role])

    return { isUserMaster, username, mainUser, userId, setMainUser  }
}